import clsx from "clsx";
import React from "react";

import styles from "./form-table.module.css";

export function FormTable({
  children,
  dataAdd,
  big,
  className,
  testId,
}: {
  children?: React.ReactNode;
  dataAdd?: boolean;
  big?: boolean;
  className?: string;
  testId?: string;
}) {
  return (
    <div
      data-testid={testId}
      className={clsx(
        styles.grid,
        dataAdd && styles.dataAdd,
        big && styles.big,
        className,
      )}
    >
      {children}
    </div>
  );
}
